import { baseRoute } from '../../../../constants/routes';

export const CALENDAR_WINNERS_ROUTE = baseRoute + '/calendar-winners';

export const UPDATE_CALENDAR_WINNERS = 'UPDATE_CALENDAR_WINNERS';
export const UPDATE_CALENDAR_WINNERS_SUCCESS = 'UPDATE_CALENDAR_WINNERS_SUCCESS';